import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "assets/images/white-logo.png";
import { useAuth } from "providers/AuthContext";
import { Button } from "components/globals/ui/input/Button";
import { FaPlus, FaMagnifyingGlass, FaBars, FaDiscord, FaCar, FaRegFlag, FaBullhorn, FaRegFile, FaPencil, FaScrewdriverWrench } from "react-icons/fa6";
import Pane from "components/modals/Pane";
import LoginForm from "components/globals/user/LoginForm";
import SearchForm from "components/globals/SearchForm";
import { FaInstagram } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa6";
import TapButton from "components/globals/ui/input/TapButton"
import ORSProfile from "components/globals/ORSProfile";

const ORSHeader = () => {
  const { userInfo, isFetching } = useAuth();
  const [loginPane, setLoginPane] = useState(false);
  const [newPane, setNewPane] = useState(false);
  const [searchPane, setSearchPane] = useState(false);
  const [mobileNavPane, setMobileNavPane] = useState(false);
  const location = useLocation();

  const showLogin = function () {
    setLoginPane(true);
  };

  const hideLogin = function () {
    setLoginPane(false);
  };

  const showNewPane = () => { 
    setNewPane(true);
  }

  const hideNewPane = () => {
    setNewPane(false);
  }

  const showSearchPane = () => { 
    setSearchPane(true);
  }

  const hideSearchPane = () => {
    setSearchPane(false);
  }

  const showMobileNavPane = () => { 
    setMobileNavPane(true);
  }

  const hideMobileNavPane = () => {
    setMobileNavPane(false);
  }

  return (
    <>
      <header className="
        block 
        fixed 
        left-0 
        w-[100vw] 
        z-[10] 
        bg-brg
        text-foreground 
        flex 
        items-center 
        flex-wrap 
        md:flex-nowrap">

        <div className="flex items-stretch w-full justify-between h-[60px]">
          
          {!isFetching && (
            <div className="flex items-stretch">
              <div 
                onClick={showMobileNavPane} 
                className="block md:hidden flex items-center px-4 border-r-[1px] border-brg-dark">
                <FaBars className="text-[16px] pointer-events-none" />
              </div>
              
              <div className="flex items-center px-5 border-r-[1px] border-brg-dark shrink-0">
                <NavLink to={userInfo ? "/" : "/welcome"}>
                  <img src={logo} alt="Open Road Society" className="block h-[26px] w-auto" />
                </NavLink>
              </div>
              
            </div>
            
          )}
          
          {userInfo ? (
            <div className="hidden md:block grow">
              <ORSMainNav />
            </div>
          ) : (
            <div className="grow flex justify-start hidden md:flex">
              <NavLink to="/articles" className={({ isActive }) => "button"}>
                {({ isActive }) => (
                  <Button size="full" border="right" variant={isActive ? "navActive" : "nav"}>
                    Articles
                  </Button>
                )}
              </NavLink>
            </div>
          )}

          <div className="flex items-stretch">
            {!isFetching && location.pathname === "/welcome" && (
              <>
                <a
                  href="https://instagram.com/open.road.society/"
                  target="blank"
                  className="flex items-center hover:bg-brg-light border-l-[1px] border-l-brg-dark text-[20px] px-4 text-white"
                >
                  <FaInstagram />
                </a>

                <a
                  href="https://discord.gg/dt6Uu7zz"
                  target="blank"
                  className="flex items-center hover:bg-brg-light border-l-[1px] border-l-brg-dark text-[20px] px-4 text-white"
                >
                  <FaDiscord />
                </a>

                {userInfo ? (
                  <div className="px-2 flex items-center border-l-[1px] border-l-brg-dark">
                    <ORSProfile />
                  </div>
                ) : (
                  <NavLink className="button" onClick={showLogin}>
                    <Button variant="nav" border="left" size='full'>Login</Button>
                  </NavLink>
                )}
              </>
            )}

            {!isFetching && location.pathname !== "/welcome" && (
              <>
                {userInfo ? null : (
                  <NavLink className="button" onClick={showLogin}>
                    <Button variant="nav" border="left" size='full'>Login</Button>
                  </NavLink>
                )}

                <span>
                  {userInfo ? (
                    <div className="flex items-stretch h-full">
                      <div 
                        className="border-l-[1px] border-l-brg-dark cursor-pointer flex items-center px-4" 
                        onClick={showSearchPane}
                      >
                        <FaMagnifyingGlass className="text-[16px] pointer-events-none" />
                      </div>
                      <div className="px-2 flex items-center border-l-[1px] border-l-brg-dark">
                        <ORSProfile />
                      </div>                     
                      
                      <div 
                        className="bg-black text-speed cursor-pointer hover:bg-speed hover:text-black transition flex items-center px-4" 
                        onClick={showNewPane}
                      >
                        <FaPlus className="text-[25px] pointer-events-none" />
                      </div>
                    </div>
                  ) : null}
                </span>
              </>
            )}
          </div>
        </div>

      </header>

      <Pane dark visible={searchPane} onClose={hideSearchPane}>
        <div className="relative mt-6">
          <SearchForm onClose={hideSearchPane} />
        </div>
      </Pane>

      <Pane dark visible={mobileNavPane} onClose={hideMobileNavPane}>
        <div className="relative mt-6">
          <ORSMobileNav />
        </div>
      </Pane>

      <Pane visible={newPane} onClose={hideNewPane}>
        <div className="relative mt-16">

          <TapButton
            link="/new/post"
            Icon={FaBullhorn}
            badge="NEW"
            title="Post"
            description="Car record, spotted, listing, want-ad, etc" />

          <div className="grid grid-cols-2 gap-2 mt-2 h-full">
            <TapButton
              inGrid
              link="/new/car"
              bgColor="brg-light"
              textColor="white"
              Icon={FaCar}
              badge="NEW"
              title="Car"
              description="Add a car to your garage" />

            <TapButton
              inGrid
              link="/new/project"
              bgColor="brg-light"
              textColor="white"
              Icon={FaScrewdriverWrench}
              badge="NEW"
              title="Project"
              description="Sub-items that live under cars to track builds, restorations, etc" />

            <TapButton
              inGrid
              link="/new/event"
              bgColor="brg-light"
              textColor="white"
              Icon={FaRegFlag}
              badge="NEW"
              title="Event"
              description="Hosting an event that you want to share? Create that here." />

            <TapButton
              inGrid
              link="/new/resource"
              bgColor="brg-light"
              textColor="white"
              Icon={FaRegFile}
              badge="NEW"
              title="Resource"
              description="Helpful info for others with the same car as you (wiring diagram, etc)." />

            <TapButton
              inGrid
              link="/new/note"
              bgColor="brg-light"
              textColor="white"
              Icon={FaPencil}
              badge="NEW"
              title="Car Note"
              description="Documentation for your car (carfax, torque specs, reciepts, etc)." />

          </div>
        </div>

      </Pane>

      <Pane dark visible={loginPane} onClose={hideLogin}>
        <LoginForm onClose={hideLogin} />
      </Pane>
    </>
  );
};

const ORSMainNav = () => {
  return (
    <div className="flex w-full h-full justify-start grow">
      <NavLink to="/cars" className={({ isActive }) => "button"}>
        {({ isActive }) => (
          <Button size="full" border="right" variant={isActive ? "navActive" : "nav"}>
            Cars
          </Button>
        )}
      </NavLink>

      <NavLink to="/society" className={({ isActive }) => "button"}>
        {({ isActive }) => (
          <Button size="full" border="right" variant={isActive ? "navActive" : "nav"}>
            Society
          </Button>
        )}
      </NavLink>

      <NavLink to="/marketplace" className={({ isActive }) => "button"}>
        {({ isActive }) => (
          <Button size="full" border="right" variant={isActive ? "navActive" : "nav"}>
            Marketplace
          </Button>
        )}
      </NavLink>

      <NavLink to="/articles" className={({ isActive }) => "button"}>
        {({ isActive }) => (
          <Button size="full" border="right" variant={isActive ? "navActive" : "nav"}>
            Articles
          </Button>
        )}
      </NavLink>
    </div>
  );
};


const ORSMobileNav = () => {
  return (
    <div>
      <NavLink to="/" className="block text-white py-4 text-[30px]  flex items-center">
        <span>Home</span>
        <FaArrowRight className="text-[20px] ml-3 mt-1" />
      </NavLink>
      
      <NavLink to="/cars" className="block text-white py-4 text-[30px]  flex items-center">
        <span>Cars</span>
        <FaArrowRight className="text-[20px] ml-3 mt-1" />
      </NavLink>
      
      <div className="py-2 flex items-stretch flex-wrap">
        <MobileLink to='/cars/brands' text='Brands' />
        <MobileLink to='/cars/users' text='User Cars' />
        <MobileLink to='/cars/spotted' text='Spotted' />
      </div>

      <NavLink to="/society" className="block text-white py-4 text-[30px]  flex items-center">
        <span>Society</span>
        <FaArrowRight className="text-[20px] ml-3 mt-1" />
      </NavLink>

      <div className="py-2 flex items-stretch flex-wrap">
        <MobileLink to='/society/members' text='Members' />
        <MobileLink to='/society/events' text='Events' />
        <MobileLink to='/society/rallys' text='Rallys' />
      </div>

      <NavLink to="/marketplace" className="block text-white py-4 text-[30px]  flex items-center">
        <span>Marketplace</span>
        <FaArrowRight className="text-[20px] ml-3 mt-1" />
      </NavLink>

      <div className="py-2 flex items-stretch flex-wrap">
        <MobileLink to='/marketplace/listings' text='Listings' />
        <MobileLink to='/marketplace/wants' text='Want-Ads' />
      </div>

      <NavLink to="/articles" className="block text-white py-4 text-[30px]  flex items-center">
        <span>Articles</span>
        <FaArrowRight className="text-[20px] ml-3 mt-1" />
      </NavLink>

      <div className="py-2 flex items-stretch flex-wrap">
        <MobileLink to='/articles' text='Listings' />
      </div>

    </div>
  );
};


const MobileLink = function({to, text}) {
  return (
    <NavLink
      className="
        bg-white/20
        hover:bg-white/80
        hover:text-black
        transition
        mx-1
        my-1
        py-1
        px-3
        rounded-md
      " 
      to={to}>
      {text}
    </NavLink>
  )
} 



export default ORSHeader;
